import { css } from '@emotion/core';
import { pxToRem, styled, BaseSkeletonLoader } from '@feast-it/ui/light';

export const SkeletonCardContainer = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[2]};
    overflow: hidden;
  `
);

export const SkeletonImage = styled(BaseSkeletonLoader)(
  ({ theme }) => css`
    width: 100%;
    border-top-left-radius: ${theme.radii[2]};
    border-top-right-radius: ${theme.radii[2]};
  `
);

export const SkeletonContent = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacing[4]};
    height: ${pxToRem(130)};
  `
);
